import React from "react";
import { useTranslation } from "react-i18next";
import HomePageNavBar from "../Components/HomePageNavBar";
import Footer from "../Components/Footer";

export default function TermsOfUse() {
  const { t } = useTranslation();
  const appName = process.env.REACT_APP_REGION_NAME;
  const operator = process.env.REACT_APP_RESPONSIBLE_ENTITY;

  return (
    <section className="bg-white body-font relative">
      <HomePageNavBar showBlackLogo/>

      <div className="bg-white h-full items-center mt-20 py-5 xl:px-0 px-10 mx-auto max-w-screen-lg lg:mx-20 xl:mx-auto">
        {/* NEW TERMS OF USE CONTENT - Updated according to user requirements */}
        <p className="font-sans font-semibold text-black mb-1 text-3xl title-font">
          {t("NewTermsTitle")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          1. {t("NewTermsIntroTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsIntro")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          2. {t("NewTermsDefinitionsTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsDefinitions")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          3. {t("NewTermsContractTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsContract")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          4. {t("NewTermsAccountTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsAccount")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          5. {t("NewTermsServicesTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsServices")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          6. {t("NewTermsObligationsTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsObligations")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          7. {t("NewTermsLicenseTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsLicense")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          8. {t("NewTermsModerationTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsModeration")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          9. {t("NewTermsReportingTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsReporting")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          10. {t("NewTermsLiabilityTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsLiability")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          11. {t("NewTermsWarrantyTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsWarranty")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          12. {t("NewTermsDataPrivacyTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsDataPrivacy")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          13. {t("NewTermsExternalLinksTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsExternalLinks")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          14. {t("NewTermsTerminationTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsTermination")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          15. {t("NewTermsCostsTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsCosts")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          16. {t("NewTermsChangesTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsChanges")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          17. {t("NewTermsFinalTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsFinal")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          18. {t("NewTermsSeverabilityTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsSeverability")}
        </p>
        <br />

        <p className="font-sans font-bold text-black mb-1 text-2xl title-font">
          19. {t("NewTermsContactTitle")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("NewTermsContact")}
        </p>
        <br />

        {/* OLD TERMS OF USE CONTENT - Commented out but preserved for reference */}
        {/*
        <p className="font-sans font-semibold text-black  mb-1 text-3xl title-font">
          {t("termsofuse")}
        </p>
        <br />
           <p className="font-sans font-bold text-black  mb-1 text-xl title-font">
          {t("introAndScope")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("tersmOfUseGlance1")}
        </p>
         <br />
          <br />
           <p className="font-sans font-bold text-black  mb-1 text-xl title-font">
          {t("DefinationsAndTerms")}
        </p>
         <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("tersmOfUseGlance2")}
        </p>
        <br />
           <p className="font-sans font-bold text-black  mb-1 text-xl title-font">
          {t("ConclusionAndRegistration")}
        </p>
         <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("tersmOfUseGlance3")}
        </p>
        <br />

        <p className="font-sans font-bold text-black  mb-1 text-xl title-font">
          {t("accountLoginDetails")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("accountLoginDetails1")}
        </p>
        <br />

        <p className="font-sans font-bold text-black  mb-1 text-xl title-font">
          {t("ObligationsOfTheUsers")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("ObligationsOfTheUsers1")}
        </p>
        <br />
        <p className="font-sans font-bold text-black  mb-1 text-xl title-font">
          {t("ObligationsOfTheUsersRule")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("ObligationsOfTheUsers2")}
        </p>
        <br />
         <p className="font-sans font-bold text-black  mb-1 text-xl title-font">
          {t("ObligationsOfTheUsersRule")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("ObligationsOfTheUsers3")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("ObligationsOfTheUsers4")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("ObligationsOfTheUsers5")}
        </p>
        <br />

        <p className="font-sans font-bold text-black  mb-1 text-xl title-font">
          {t("RightsOfUse")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("RightsOfUse1")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("RightsOfUse2")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("RightsOfUse3")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("RightsOfUse4")}
        </p>
        <br />

        <p className="font-sans font-bold text-black  mb-1 text-xl title-font">
          {t("TermsLiability")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("TermsLiability1")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("TermsLiability2")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("TermsLiability3")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("TermsLiability4")}
        </p>
        <br />

        <p className="font-sans font-bold text-black  mb-1 text-xl title-font">
          {t("IndemnificationClaim")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("IndemnificationClaim1")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("IndemnificationClaim2")}
        </p>
        <br />

        <p className="font-sans font-bold text-black  mb-1 text-xl title-font">
          {t("TerminationOfTheUserRelationship")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("TerminationOfTheUserRelationship1")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("TerminationOfTheUserRelationship2")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("TerminationOfTheUserRelationship3")}
        </p>
        <br />
        <p className="font-sans font-bold text-black  mb-1 text-xl title-font">
          {t("FinalProvisions")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("FinalProvisions1")}
        </p>
        <br />
        <p className="font-sans font-semibold text-black mb-1 text-sm title-font">
          {t("FinalProvisions2")}
        </p>
        <br />
        */}
      </div>

      <div className="bottom-0 w-full">
        <Footer />
      </div>
    </section>
  );
}
